import React from 'react';
import TicketList from '@/components/ticket/list';

export default () => <TicketList />;
